import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import "./Stats.scss";
import { Fade } from "../../components/FadeReveal/FadeReveal";
import StyleContext from "../../contexts/StyleContext";
import { statsSection } from "../../portfolio";

export default function Stats() {
  const { isDark } = useContext(StyleContext);
  const { t } = useTranslation();
  
  if (!statsSection.display) {
    return null;
  }

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className={isDark ? "dark-mode main" : "main"} id="stats">
        <div className="stats-header-div">
          <h1 className={isDark ? "dark-mode stats-heading" : "stats-heading"}>
            {t('stats.title')}
          </h1>
          <p className={isDark ? "dark-mode stats-subtitle" : "stats-subtitle"}>
            {t('stats.subtitle')}
          </p>
        </div>
        <div className="stats-cards-div">
          {statsSection.data.map((stat, i) => {
            // Create translation key mapping for stat labels
            const getTranslationKey = (label) => {
              switch(label) {
                case "Years Experience": return "stats.yearsExperience";
                case "Projects Delivered": return "stats.projectsDelivered";
                case "UX Improvement": return "stats.uxImprovement";
                case "Clients Collaborated With": return "stats.clientsCollaborated";
                case "AI Integrations": return "stats.aiIntegrations";
                case "System Uptime": return "stats.systemUptime";
                default: return label;
              }
            };

            return (
              <Fade bottom duration={1000} distance="20px" key={i}>
                <div className={`stat-card ${isDark ? "dark-mode" : ""}`}>
                  <div className="stat-content">
                    <div className="stat-icon">{stat.icon}</div>
                    <div className="stat-number">{stat.number}</div>
                    <div className="stat-label">{t(getTranslationKey(stat.label))}</div>
                  </div>
                </div>
              </Fade>
            );
          })}
        </div>
      </div>
    </Fade>
  );
}